<template>
  <div>
    <el-dialog
      top="0"
      custom-class="feedback"
      :visible="feedbackDialogVisible"
      :show-close="false"
      width="680px"
      center
      :style="[leftStyle]"
    >
      <div class="custom-header" slot="title">
        <div class="dialog-title tabheader">
          <span>[资料ID: {{ documentInfo.documentId }}] &nbsp;{{ title }}</span>
          <div class="close-btn" data-io-click="tracker"  @click.stop="handleCustomClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <el-form
        style="padding: 25px 0 0 23px"
        v-if="feedbacktabArr[0]"
        @submit.native.prevent
      >
        <div style="margin-bottom: 12px">
          <span class="icon-xing">*</span
          ><span class="sub-title">错误类型:</span>
        </div>
        <div class="option">
          <span class="name">类型</span>
          <div
            data-io-click="tracker"  @click="buildTitle(i, 0)"
            class="single-option"
            :class="{ active: selectTypeIdList.includes(i.id) }"
            v-for="i in typeErrorList"
            :key="i.id"
          >
            {{ i.value }}
          </div>
        </div>
        <div class="option">
          <span class="name">内容</span>
          <div
            data-io-click="tracker"  @click="buildTitle(i, 1)"
            class="single-option"
            v-for="i in contentErrorList"
            :class="{ active: selectContentIdList.includes(i.id) }"
            :key="i.id"
          >
            {{ i.value }}
          </div>
        </div>
        <div class="option">
          <span class="name">其他</span>
          <div
            data-io-click="tracker"  @click="buildTitle(i, 2)"
            class="single-option"
            v-for="i in otherErrorList"
            :class="{ active: selectOtherIdList.includes(i.id) }"
            :key="i.id"
          >
            {{ i.value }}
          </div>
        </div>

        <div style="margin-bottom: 12px">
          <span class="icon-xing">*</span
          ><span class="sub-title"
            >描<span style="margin-left: 2em">述</span>:</span
          >
        </div>
        <div class="option" style="margin-bottom: 6px">
          <el-input
            maxlength="800"
            show-word-limit
            type="textarea"
            placeholder="请详细填写问题描述，改进要求"
            v-model="description"
            rows="4"
            resize="none"
          ></el-input>
        </div>
        <div class="image-upload-tips">支持多选，上限5张，单张2MB内</div>
        <div class="upload-wrapper">
          <el-upload
            class="upload-inner"
            :on-preview="handlePreview"
            action="/wxtapi/v1/upload/upload-image"
            list-type="picture-card"
            :on-remove="handleRemove"
            :limit="5"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :before-upload="beforeUpload"
            multiple
          >
            <svg class="icon shangchuantupian" aria-hidden="true">
              <use xlink:href="#icon-add"></use>
            </svg>
            <span class="texttip">上传图片</span>
          </el-upload>
        </div>
        <button data-io-click="tracker"  @click.stop="handleCustomClose" class="submit-close">
          取消
        </button>
        <button
          data-io-click="tracker"  @click="uploadFeedBack"
          class="submit"
          :class="{ active: title != '' && description != '' }"
        >
          提交
        </button>
      </el-form>
      <div class="bottom-tips">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7.3999 4H8.59985V5.19995H7.3999V4ZM7.50562 6.5H8.50562V11.9998H7.50562V6.5Z"
            fill="#F58800"
          />
        </svg>
        温馨提示：凡参与挑错将会获得
        <span style="color: #f14848">0-10元</span>
        奖励哦，奖励将在归档后发放，点击查看
        <span
          style="color: #0057ff; cursor: pointer"
          data-io-click="tracker"  @click="toUserSuggestion()"
          >挑错处理进展</span
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      top="0"
      style="height: 90vh"
      custom-class="feedback-img-preview"
    >
      <div style="max-height: calc(90vh - 60px); overflow-y: auto">
        <img width="100%" height="auto" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "@/assets/js/common/util";
import api from "@/assets/js/service/api";
import request from "@/utils/request";
export default {
  inject: ["textbook"],
  props: {
    feedbackDialogVisible: {
      type: Boolean,
      default: false,
    },
    // 意见反馈类型
    type: {
      type: String,
      default: "挑错",
    },
    documentInfo: {
      type: Object,
      default: { documentId: 0 },
    },
    documentId: {
      type: Number,
      default: null,
    },
    albumId: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      feedbacktabArr: [1, 0, 0],
      pageIndex: 0,
      loading: false,
      isNoMore: false,
      fbDetail: {},
      // 是否上传中
      uploading: false,
      uploadImgs: [],
      title: "",
      selectTitleList: [],
      description: "",
      typeErrorList: [
        { id: 1, value: "标题有误" },
        { id: 2, value: "标题与内容不符" },
      ],
      contentErrorList: [
        { id: 1, value: "内容有误" },
        { id: 2, value: "内容残缺" },
        { id: 3, value: "图片不清晰" },
        { id: 4, value: "内容虚假" },
      ],
      otherErrorList: [
        { id: 1, value: "归类错误" },
        { id: 2, value: "解压乱码" },
        { id: 3, value: "无法下载" },
        { id: 4, value: "其他错误" },
        { id: 5, value: "提出建议" },
      ],
      selectTypeIdList: [0, 0],
      selectContentIdList: [0, 0, 0, 0],
      selectOtherIdList: [0, 0, 0, 0, 0],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  mounted() {
    if (this.documentId != null) {
      this.documentInfo.documentId = this.documentId;
    }
    // this.$nextTick(() => {
    //   // console.log(document.getElementsByClassName("el-dialog__body")[0]);
    //   document
    //     .getElementsByClassName("el-dialog__body")[0]
    //     .addEventListener(
    //       "scroll",
    //       util.throttle(this.handleScroll, 500),
    //       true
    //     );
    //   // this.handleScroll()
    // });
    // this.getFeedBackList();
    // this.getFeedBackTypes();
  },
  computed: {
    leftStyle() {
      if (this.textbook.isInIframe) {
        return {
          left: -(this.textbook.asideWidth / 2) + "px",
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    handlePreview(file) {
      // window.open(file.response.result.filePath);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleCustomClose() {
      this.selectTitleList = [];
      this.selectTypeIdList = [];
      this.selectOtherIdList = [];
      this.selectContentIdList = [];
      this.$emit("closeModal");
    },
    // 上传进行时
    handleProgress() {
      this.uploading = true;
    },
    handleExceed(files) {
      if (this.uploadImgs.length + files.length > 5) {
        this.$message({
          type: "warning",
          message: "最多可上传五张哦~",
        });
        return;
      }
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      this.uploading = false;
      this.uploadImgs = fileList.map((item) => {
        return item.response.result.filePath;
      });
    },
    handleRemove(file, fileList) {
      this.uploadImgs = fileList.map((item) => {
        return item.response?.result.filePath;
      });
    },
    checkfbDetail(item) {
      this.feedbacktabArr = [0, 0, 1];
      request
        .get(api.feedback.getUserQuestion, {
          questionId: item.id,
        })
        .then((res) => {
          this.fbDetail = res.result;
          res.result.handerResult = item.handerResult;
        });
    },
    beforeUpload(file) {
      const isStatus = file.type.indexOf("image/") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isStatus) {
        this.$message.error({
          message: "上传的图片格式错误",
          offset: this.getNextMessageOffset(), // 动态设置偏移量
        });
        return isStatus;
      }
      if (!isLt2M) {
        this.$message.error({
          message: "上传的图片大小超过2M",
          offset: this.getNextMessageOffset(), // 动态设置偏移量
        });
        return isLt2M;
      }
      return isStatus && isLt2M;
    },
    uploadFeedBack() {
      this.pageIndex = 0;
      if (this.uploading) {
        this.$message({
          type: "warning",
          message: "图片正在上传中",
        });
        return;
      }
      //验证是否可提交
      if (this.title == "") {
        this.$message({
          type: "warning",
          message: "请选择错误类型~",
        });
        return;
      }
      if (this.description == "") {
        this.$message({
          type: "warning",
          message: "请输入错误描述~",
        });
        return;
      }
      request
        .post(api.feedback.putUserQuestion, {
          entityId: this.documentInfo.documentId,
          sourceId: this.documentInfo.documentId,
          title: `[资料ID: ${this.documentInfo.documentId}]` + this.title,
          entityType: "RESOURCE",
          callbackUrl: `https://${window.location.host}.xkw.com/soft/${this.documentInfo.documentId}-1.html`,
          // courseId: this.documentInfo.course.id,
          description: this.description,
          type: "CONTENT",
          images: this.uploadImgs,
        })
        .then((res) => {
          if (res.result.status) {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.feedbacktabArr = [0, 1, 0];
            this.loading = false;
            this.isNoMore = false;
            this.pageIndex = 0;
            this.handleCustomClose();
          } else {
            this.$message({
              type: "error",
              message:
                res.result.errorMessage == "sourceId重复，请检查参数！"
                  ? "你已提交过此资料的挑错建议！"
                  : res.result.errorMessage,
            });
            this.feedbacktabArr = [1, 0, 0];
            this.loading = false;
            this.isNoMore = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "提交失败",
          });
        });
    },
    // handleScroll() {
    //   let listContent = document.getElementsByClassName("el-dialog__body")[0];
    //   let scrollTop = listContent.scrollTop,
    //     clientHeight = listContent.clientHeight,
    //     scrollHeight = listContent.scrollHeight,
    //     height = 50; //根据项目实际定义
    //   if (scrollTop + clientHeight >= scrollHeight - height) {
    //     this.getFeedBackList();
    //   }
    // },
    toService() {
      window.open(
        "https://webchat-bj.clink.cn/chat.html?accessId=b99757dc-4d2a-4219-83bb-46289b108c8a&tinetWebChatType=tinetResponsive&language=zh_CN"
      );
    },
    buildTitle(data, item) {
      if (item == 0) {
        if (this.selectTypeIdList.indexOf(data.id) !== -1) {
          this.selectTypeIdList.splice(
            this.selectTypeIdList.indexOf(data.id),
            1
          );
          this.selectTitleList.splice(
            this.selectTitleList.indexOf(data.value),
            1
          );
        } else {
          this.selectTypeIdList.push(data.id);
          this.selectTitleList.push(data.value);
        }
      }
      if (item == 1) {
        if (this.selectContentIdList.indexOf(data.id) !== -1) {
          this.selectContentIdList.splice(
            this.selectContentIdList.indexOf(data.id),
            1
          );
          this.selectTitleList.splice(
            this.selectTitleList.indexOf(data.value),
            1
          );
        } else {
          this.selectContentIdList.push(data.id);
          this.selectTitleList.push(data.value);
        }
      }
      if (item == 2) {
        if (this.selectOtherIdList.indexOf(data.id) !== -1) {
          this.selectOtherIdList.splice(
            this.selectOtherIdList.indexOf(data.id),
            1
          );
          this.selectTitleList.splice(
            this.selectTitleList.indexOf(data.value),
            1
          );
        } else {
          this.selectOtherIdList.push(data.id);
          this.selectTitleList.push(data.value);
        }
      }
      this.title = this.selectTitleList.join("、");
    },
    toUserSuggestion() {
      window.open("/user/suggestion");
    },
    // 计算下一个提示框的偏移量
    getNextMessageOffset() {
      const MESSAGE_HEIGHT = 50; // 每个提示框的高度，根据实际情况调整
      const existingMessages = document.querySelectorAll(".el-message"); // 获取当前页面上所有的提示框
      return existingMessages.length * MESSAGE_HEIGHT + 20; // 动态计算偏移量
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .feedback {
  height: 630px;
  font-size: 14px;
  .tabheader > span {
    font-size: 16px;
  }
  .tabheader > span.active {
    color: #0057ff;
  }
  .el-textarea {
    width: 637px;
    margin-left: 11px;
    .el-input__count {
      right: 18px;
    }
  }
  .el-radio-group {
    text-align: left;
  }
  .icon-xing {
    color: #fe0000;
    font-family: "Alibaba PuHuiTi";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    letter-spacing: 0.35px;
  }
  .sub-title {
    color: var(-----xkw-font-sectitle-color, #7e7e7e);

    /* regular/--xkw-body-regular */
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    margin-left: 4px;
  }
  .option {
    position: relative;
    margin-bottom: 20px;
    text-align: left;
    .name {
      line-height: 28px;
      font-size: 14px;
      color: var(-----xkw-font-primary-color, #1a1a1a);

      /* regular/--xkw-body-regular */
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      margin-left: 11px;
    }
    .single-option {
      display: inline-block;
      padding: 0px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      border: 1px solid var(-----xkw-avatar-color, #bababa);
      background: var(-----xkw-bg-container-color, #fff);

      color: var(-----xkw-font-sectitle-color, #7e7e7e);
      text-align: center;
      /* regular/--xkw-body-regular */
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 157.143% */

      margin-left: 16px;

      &:hover {
        border: 1px solid #0057ff;
        background: var(-----xkw-bg-container-color, #fff);
        color: #0057ff;
        cursor: pointer;
      }

      &.active {
        color: #0057ff;
        border-radius: 6px;
        border: 1px solid #0057ff;
        background: var(-----xkw-brand-color-light, #e6f2ff);
      }
    }
  }
  .image-upload-tips {
    color: var(-----xkw-warning-color-normal, #f58800);

    /* regular/--xkw-aux-regular */
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 166.667% */
    margin-left: 11px;
  }
  .upload-wrapper {
    margin-top: 6px;
    text-align: left;
    margin-left: 11px;
    .upload-inner {
      text-align: left;
    }
    margin-bottom: 15px;
  }
  .shangchuantupian {
    width: 16px;
    height: 16px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 90px;
    height: 90px;
  }

  .el-upload--picture-card {
    width: 90px;
    height: 90px;
    position: relative;
  }

  .shangchuantupian,
  .texttip {
    position: absolute;
  }
  .shangchuantupian {
    left: 35px;
    top: 24px;
  }
  .texttip {
    font-size: 14px;
    color: #999;
    height: 12px;
    line-height: 12px;
    top: 57px;
    left: 16px;
  }
  .submit-close {
    display: flex;
    width: 88px;
    height: 32px;
    min-width: 64px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 6px;
    border: 1px solid var(-----xkw-border-color, #e2e2e2);
    background: var(-----xkw-bg-container-color, #fff);

    color: var(-----xkw-font-sectitle-color, #7e7e7e);
    text-align: center;

    /* regular/--xkw-body-regular */
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */

    cursor: pointer;
    position: absolute;
    right: 120px;
    bottom: 47px;

    &:hover {
      border: 1px solid #0057ff;
      color: #0057ff;
    }
  }
  .submit {
    display: flex;
    width: 88px;
    height: 32px;
    min-width: 64px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: var(----xkw-medium-radious, 6px);
    background: var(-----xkw-brand-color-disabled, #9cf);

    color: var(-----xkw-font-anti-color, #fff);
    text-align: center;
    /* regular/--xkw-body-regular */
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */

    cursor: pointer;
    position: absolute;
    right: 16px;
    bottom: 47px;

    &.active {
      background: #0057ff;

      &:hover {
        background: #4494ff;
      }
    }
  }
  .el-radio__inner,
  .el-radio__input,
  .el-radio__original {
    display: none;
  }
  .el-radio__label {
    padding-left: 0;
  }
  .el-radio--mini.is-bordered {
    padding: 6px 15px 0 15px;
    border-radius: 25px;
  }
  .el-radio.is-bordered.is-checked {
    background-color: #e5f7fe;
    border-color: #0057ff;
    color: #0057ff;
  }
  .el-upload--picture-card:hover {
    opacity: 0.8;
  }
  .el-upload:focus {
    border-color: #c0ccda;
  }
  .el-radio {
    margin-left: 0px !important;
  }
  .list-content {
    color: #333;
    line-height: 30px;
    li {
      border-bottom: 1px solid #e6e7e9;
      padding-bottom: 12px;
      padding-top: 12px;
      text-align: left;
    }
    li > div {
      > * {
        margin-right: 20px;
      }
      .status {
        margin-left: 20px;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .nothing {
    text-align: center;
    margin-top: 100px;
    img {
      width: 120px;
      height: auto;
    }
  }
  .fbdail {
    padding: 18px 0 0 24px;
    line-height: 14px;
    text-align: left;
    > div {
      margin-bottom: 18px;
      span {
        margin-right: 16px;
      }
    }

    .img-box {
      img {
        float: left;
        border: 1px solid #bebebe;
        margin-right: 16px;
        &:nth-of-type(5) {
          margin-right: 0px;
        }
      }
    }
    .fbfooter {
      font-size: 12px;
      background: #f9df91;
      text-align: center;
      height: 33px;
      line-height: 33px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 680px;
      margin: 0;
      border-radius: 0 0 8px 8px;
    }
  }
}
::v-deep .el-dialog__header {
  text-align: left;
  height: auto !important;
  min-height: 58px;
}
.clearfix {
  display: block;
}
.custom-header {
  position: relative;
  width: 100%;

  .dialog-title {
    padding-right: 30px; /* 为关闭按钮留出空间 */
  }

  .close-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      font-size: 18px;
      color: #909399;
      transition: color 0.2s;
    }

    &:hover i {
      color: #333;
    }
  }
}
.bottom-tips {
  display: flex;
  width: 680px;
  height: 32px;
  padding: 0px 16px;
  align-items: center;
  gap: 4px;
  border-radius: 0px 0px 8px 8px;
  background: var(-----xkw-warning-color-light, #fff6d3);

  color: var(-----xkw-font-sectitle-color, #7e7e7e);
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
  bottom: 0;
  position: absolute;
}

.el-textarea {
  /*滚动条整体部分*/
  ::v-deep .el-textarea__inner::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  /*滚动条的轨道*/
  ::v-deep .el-textarea__inner::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  /*滚动条里面的小方块，能向上向下移动*/
  ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
    border-radius: 5px;
    border: 1px solid #f1f1f1;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  }
  ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144, 147, 153, 0.3);
  }
  ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb:active {
    background-color: rgba(144, 147, 153, 0.3);
  }
  /*边角，即两个滚动条的交汇处*/
  ::v-deep .el-textarea__inner::-webkit-scrollbar-corner {
    background-color: #ffffff;
  }
}
</style>
